module.exports = __webpack_public_path__ + "media/images/proof_links/colored/foursquare-1fc13d17f74f7be438e03ffaf39b506a.svg";